<style lang="stylus" scoped>
    .recommend-lv2
        position relative
        margin-top 24px
        .lv2-title
            width 100%
            height 20px
            font-size 16px
            font-weight 700
            color #222
            margin-bottom 24px
        .scroll-control
            position absolute
            left 0
            top 44px
            width 100%
            .arrow
                position absolute
                display flex
                justify-content center
                align-items center
                right -16px
                top 12px
                width 32px
                height 32px
                cursor pointer
                border-radius 50%
                background #fff
                z-index 10
                box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.05), 0px 2px 10px 0px rgba(0, 0, 0, 0.08)
                &:hover
                    background rgb(242,244,249)
            .left-arrow
                left -16px
                right 0
                img
                    transform rotate(180deg)

        .lv2-box
            position relative
            max-width 100%
            height 56px
            display flex
            overflow-x scroll
            overflow-y visible
            &::-webkit-scrollbar
                display none

            .lv2-item
                display flex
                align-items center
                column-gap 16px
                width 204px
                height 56px
                padding 8px 16px
                border-radius 8px
                border: 1px solid #00000014
                flex-shrink 0
                cursor pointer
                &:not(:last-child)
                    margin-right 16px
                &:hover
                    border-color var(--themeColor)
                &.active
                    border-width 2px
                    border-color var(--themeColor)
                img
                    width 40px
                    height 40px
                p
                    font-size 14px
                    color #000
                    display -webkit-box
                    -webkit-line-clamp 2
                    -webkit-box-orient vertical
                    overflow hidden
                    text-overflow ellipsis
</style>

<template>
    <div class="recommend-lv2">
        <div class="lv2-title">{{ title }}</div>

        <div class="scroll-control">
            <div class="arrow left-arrow" v-show="canscrollLeft" @click="scrollToLeft">
                <img src="@/home/assets/img/newPage/recommend-new/right-arrow.svg" alt="" />
            </div>
            <div class="arrow" v-show="canscrollRight" @click="scrollToRight">
                <img src="@/home/assets/img/newPage/recommend-new/right-arrow.svg" alt="" />
            </div>
        </div>

        <div class="lv2-box" ref="lv2box">
            <div v-if="from == 'homepage'" class="lv2-item" :data-id="-1" :class="{ active: -1 == activeLv2Id }" @click="reset()">
                <img src="@/home/assets/img/newPage/recommend-new/lv2-all.svg" alt="" />
                <p :title="$t('all')">{{ $t("all") }}</p>
            </div>
            <div
                class="lv2-item"
                :data-id="item.id"
                :class="{ active: from == 'homepage' && item.id == activeLv2Id }"
                v-for="item in list"
                @click="clickLv2(item)"
                :key="item.name"
            >
                <img :src="item.img_url" alt="" />
                <p :title="lang == 'en' ? item.name : item['name_' + lang] || '-'">{{ lang == "en" ? item.name : item["name_" + lang] || "-" }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class RecommendLv2 extends Vue {
        @Prop()
        title;
        @Prop()
        list;
        @Prop({ default: "homepage" })
        from;

        canScroll = false;
        canscrollLeft = false;
        canscrollRight = false;
        checkScroll() {
            let el = this.$refs.lv2box as HTMLElement;
            if (el) {
                this.canScroll = el.clientWidth != el.scrollWidth;
                this.canscrollLeft = el.scrollLeft > 0;
                this.canscrollRight = el.scrollWidth - el.scrollLeft > el.clientWidth;
            }
        }
        scrollTo(position = 0) {
            let el = this.$refs.lv2box as HTMLElement;
            if (el) {
                const onScroll = (e) => {
                    if (el.scrollLeft == position) {
                        this.checkScroll();
                        el.removeEventListener("scroll", onScroll);
                    }
                };
                el.addEventListener("scroll", onScroll);
                el.scrollTo({
                    behavior: "smooth",
                    left: position,
                });
            }
        }
        scrollToRight() {
            let el = this.$refs.lv2box as HTMLElement;
            if (el) {
                const maxLeft = el.scrollWidth - el.clientWidth;
                let left = el.scrollLeft + 300;
                left = left < maxLeft ? left : maxLeft;
                this.scrollTo(left);
            }
        }
        scrollToLeft() {
            let el = this.$refs.lv2box as HTMLElement;
            if (el) {
                let left = el.scrollLeft - 300;
                left = left > 0 ? left : 0;
                this.scrollTo(left);
            }
        }
        resetScroll() {
            let el = this.$refs.lv2box as HTMLElement;
            el &&
                el.scrollTo({
                    left: 0,
                });
            this.canScroll = false;
            this.canscrollLeft = false;
            this.canscrollRight = false;
            this.$nextTick(() => {
                this.checkScroll();
            });
        }

        // click event
        activeLv2Id = -1;
        setLv2Id(id) {
            this.activeLv2Id = id;
            this.scrollToView(id);
        }
        clickLv2(item) {
            this.activeLv2Id = item.id;
            this.scrollToView(item.id);
            this.$emit("clickLv2", item);
        }
        resetLv2() {
            this.activeLv2Id = -1;
        }
        reset() {
            this.scrollToView(-1);
            this.resetLv2();
            this.$emit("resetLv2");
        }
        scrollToView(id) {
            let el = this.$refs.lv2box as HTMLElement;
            const boxWidth = el.clientWidth,
                boxScrollLeft = el.scrollLeft;
            if (el) {
                let child = el.children;
                for (let i = 0; i < child.length; i++) {
                    let item = child[i];
                    if (item instanceof HTMLDivElement && item.dataset.id == `${id}`) {
                        const itemWidth = item.clientWidth,
                            itemLeft = item.offsetLeft;
                        const rightOffset = itemLeft + itemWidth - boxScrollLeft - boxWidth + 2;
                        const LeftOffset = boxScrollLeft - itemLeft;
                        if (rightOffset > 0) {
                            this.scrollTo(boxScrollLeft + rightOffset);
                        }
                        if (LeftOffset > 0) {
                            this.scrollTo(boxScrollLeft - LeftOffset);
                        }
                        break;
                    }
                }
            }
        }

        @Watch("list", { immediate: true })
        resetOption() {
            console.log("reset");
            this.resetScroll();
            this.resetLv2();
        }

        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "all": "全部"
    },
    "en": {
        "all": "All"
    },
    "fr": {
        "all": "Tout"
    },
    "de": {
        "all": "Alle"
    },
    "jp": {
        "all": "すべて"
    },
    "es": {
        "all": "Todo"
    },
    "pt": {
        "all": "Todos"
    },
    "it": {
        "all": "tutto"
    },
    "tw": {
        "all": "全部"
    },
    "kr": {
        "all": "모두"
    }
}
</i18n>
